import { node } from '../../../utils/dom'
import { getIsDesktop } from '../../../utils/ua'
import BaseAdView from './BaseAdView'
import { createElementWithCallback } from '../../../utils/mithril'
import { AD_FORMATS, CLASS_NAMES } from '../../config/adsConfig'
import { getPageDomain } from '../../../application/pageDataObject'
import { queryString, addOnOrientationChangeEvent } from '../../../utils/window'

const { STICKY } = CLASS_NAMES
const { debugStickyHeader } = queryString
let topSlot = null

function displayStickyAdForSite(stickyConf) {
  return (
    !stickyConf.exceptOnSites ||
    stickyConf.exceptOnSites.length === 0 ||
    stickyConf.exceptOnSites.some(site => site !== getPageDomain())
  )
}

function isSticky(stickyConf) {
  const isStickyByDefault = stickyConf.default
  const isStickyNotBlacklisted = isStickyByDefault && displayStickyAdForSite(stickyConf)
  const isntStickyAndWhitelisted = !isStickyByDefault && !displayStickyAdForSite(stickyConf)
  return isStickyNotBlacklisted || isntStickyAndWhitelisted
}

export default class RegularAdView extends BaseAdView {
  view(ctrl) {
    return createElementWithCallback('div', this.renderParams)
  }

  adjustTopSlot() {
    // eslint-disable-line complexity
    topSlot = topSlot || node(`.ad[data-slot-id="${AD_FORMATS.Top}"]`)
    if (!topSlot) {
      return this
    }
    const { topHeight, stickyConf } = this.adVm
    if (getIsDesktop() && topSlot && topHeight) {
      topSlot.style.height = `${topHeight + 24}px`
    }
    if (isSticky(stickyConf)) {
      if (!topSlot.classList.contains(STICKY)) {
        if (debugStickyHeader) {
          this.info(`adding class '${STICKY}' to top slot`, { topSlot })
        }
        topSlot.classList.add(STICKY)
      }
    } else {
      if (topSlot.classList.contains(STICKY)) {
        // eslint-disable-line no-lonely-if
        if (debugStickyHeader) {
          this.info(`removing class '${STICKY}' to top slot`, { topSlot })
        }
        topSlot.classList.remove(STICKY)
      }
    }
    return this
  }

  get renderParams() {
    const params = super.renderParams
    if (this.adId === AD_FORMATS.Top) {
      addOnOrientationChangeEvent(this.adjustTopSlot.bind(this), this.adjustTopSlot.bind(this))
      this.adjustTopSlot()
    }
    return params
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/views/ads/RegularAdView.js